import React from 'react';
import { CheckCircle, Zap, GraduationCap, Users } from 'lucide-react';

const TrustSection: React.FC = () => {
  const trustItems = [
    {
      icon: <CheckCircle size={36} className="text-[#2574B5]" />,
      title: "Von KI-Experten entwickelt",
      description: "Unser Schulungskonzept wurde von erfahrenen KI-Spezialisten mit Fokus auf Praxistauglichkeit entwickelt."
    },
    {
      icon: <Zap size={36} className="text-[#2574B5]" />,
      title: "100 % online – flexibel & mobil",
      description: "Absolvieren Sie die Schulung wann und wo Sie möchten. Unsere Plattform ist für alle Geräte optimiert."
    },
    {
      icon: <GraduationCap size={36} className="text-[#2574B5]" />,
      title: "Rechtssicher nach EU AI Act",
      description: "Unser Kompetenznachweis entspricht den Vorgaben des neuen EU AI Acts und schafft Rechtssicherheit für Ihr Unternehmen."
    },
    {
      icon: <Users size={36} className="text-[#2574B5]" />,
      title: "Praxisorientierte Schulung",
      description: "Lernen Sie anhand realer Beispiele und konkreter Anwendungsfälle, wie Sie KI rechtssicher einsetzen."
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Ihr Partner für KI-Kompetenznachweis
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Wir von den KI-Navigatoren machen Sie und Ihr Team fit für den EU AI Act mit praxiserprobten Schulungen von KI-Experten. Als regional verwurzelter Dienstleister kennen wir die Herausforderungen kleiner und mittlerer Unternehmen aus erster Hand und übersetzen High-Tech in praxisfähige Lösungen.
            
            Unser Team kombiniert 20 Jahre IT-Projektpraxis mit top-aktueller KI-Expertise. Von der Schulung über den automatischen Kompetenznachweis bis zum laufenden Support in Ihren Projekten begleiten wir Sie schnell, unkompliziert und auf Wunsch auch gernpersönlich.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {trustItems.map((item, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-lg shadow-md border border-gray-100 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex flex-col items-center text-center">
                <div className="mb-6">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;